import React from 'react';
import PropTypes from 'prop-types';

import { Label, StyledInput } from './styled';

const Input = ({ label, name, id, onChange, value, placeholder, type, error }) => {
    return (
        <>
            <Label hasError={error}>{label}</Label>
            <StyledInput
                id={id}
                name={name}
                hasError={error}
                onChange={({ target: { value } }) => onChange(name, value)}
                placeholder={placeholder}
                value={value}
                type={type}
            />
        </>
    );
};

Input.defaultProps = {
    placeholder: '',
    value: '',
    type: 'text',
    error: false,
};

Input.propTypes = {
    name: PropTypes.string.isRequired,
    error: PropTypes.bool,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
};

export default Input;
